import { render, staticRenderFns } from "./HeaderModal.vue?vue&type=template&id=36140244&scoped=true&lang=html&"
import script from "./HeaderModal.vue?vue&type=script&lang=js&"
export * from "./HeaderModal.vue?vue&type=script&lang=js&"
import style0 from "./HeaderModal.vue?vue&type=style&index=0&id=36140244&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36140244",
  null
  
)

export default component.exports